<template>
  <v-row>
    <v-col>
      <v-card :loading="loading" tile>
        <v-card-title>
          <h1 class="title">Monitoring</h1>
          <v-spacer/>
          <v-btn @click="getReport" color="primary">
            Update
          </v-btn>
        </v-card-title>
        <v-card-subtitle>
      <span class="overline">
        Call at : {{ call_at }}
      </span>
          <br>
          <span class="overline">
        Uptime : {{ server.uptime }}
      </span>
        </v-card-subtitle>
        <v-card-text>
          <v-row class="my-2">
            <disk :disks="server.disks"/>
            <ram :ram="server.ram"/>
            <service :services="server.services"/>
          </v-row>
          <v-row class="my-2" v-if="server.crons">
            <cron :crons="server.crons"/>
          </v-row>
          <v-row class="my-2">
            <model :models="server.count"/>
          </v-row>
          <v-row class="my-2" v-if="server.first_and_last_entry">
            <models :models="server.first_and_last_entry" :count="server.count"/>
          </v-row>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>
<script>
import Disk from './Disk'
import Ram from './Ram'
import Service from './Service'
import Cron from './Cron'
import Model from './Model'
import Models from './Models'

export default {
  name: "monitor",
  components: {Disk, Ram, Service, Cron, Model, Models},
  data() {
    return {
      loading: false,
      server: {uptime: 'Never', disks: {}, ram: {}, services: {}, count: {}, first_and_last_entry: {}},
      call_at: new Date().toLocaleString()
    }
  },
  mounted() {
    this.getReport()
  },
  methods: {
    getReport() {
      this.loading = true
      fetch('/api/monitoring/report', {
        headers: {
          'Accept': 'application/json'
        }
      })
          .then((response) => {
            return response.json();
          })
          .then((json) => {
            this.server = json.server
            this.call_at = new Date().toLocaleString()
          }).finally(() => this.loading = false);
    }
  }
}
</script>
